import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  createHashHistory,
} from '@tanstack/react-router'
import { Login, Welcome } from '../pages'
import { ProtectedRoute } from '../components/common'
import { CustomisationProvider } from '../context/CustomisationProvider'
import { AuthProvider } from '../context/AuthProvider'
import { z } from 'zod'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

export const LOGIN_PATH = '/' as const
export const WELCOME_ROUTE_PATH = '/welcome' as const

const rootRoute = createRootRoute({
  component: () => (
    <CustomisationProvider>
      <AuthProvider>
        <Outlet />
        <TanStackRouterDevtools />
      </AuthProvider>
    </CustomisationProvider>
  ),
})

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: LOGIN_PATH,
  component: Login,
  validateSearch: z.object({
    from: z.string().optional(),
  }),
})

const welcomeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: WELCOME_ROUTE_PATH,
  component: () => (
    <ProtectedRoute>
      <Welcome />
    </ProtectedRoute>
  ),
})

const routeTree = rootRoute.addChildren([loginRoute, welcomeRoute])

export const router = createRouter({
  routeTree,
  history: createHashHistory(),
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
